export const downcaseArray = (arr) => {
  return arr.map(e => {
    return e.toLowerCase();
  })
}
